/** @jsx jsx */
import { jsx } from 'theme-ui';
import Link from '../Link/Link';
/**
 *
 * @param {object} props
 * @param {() => void} [props.onClick]
 * @param {string} [props.to]
 * @param {string} [props.href]
 * @param {React.ReactNode} [props.children]
 * @param {import('./buttonVariants').ButtonVariant} [props.variant]
 * @param {string} [props.type] The button type (submit or button).
 * @param {string} [props.fallback]
 * @param {boolean} [props.openInNewTab] Opens external links in new tabs.
 * @returns
 */
export default function Button({
  onClick,
  to,
  href,
  children,
  variant = 'default',
  fallback = 'button',
  ...rest
}) {
  return (
    <Link
      onClick={onClick}
      to={to}
      href={href}
      sx={{ variant: `button.${variant}` }}
      variant="button"
      fallback={fallback}
      type="button"
      {...rest}
    >
      {children}
    </Link>
  );
}
